import App from '@/models/App'

export default class ShipTop extends App {
    static get entity() {
        return 'ShipTops'
    }
    static one() {
        return this.query().withAllRecursive().first()
    }
    static fields() {
        return {
            id: this.attr(''),
            shipId: this.attr(''),
            voyageNo: this.attr(0),
            currentSpeed: this.attr(0),
            averageSpeed: this.attr(0),
            lsmgo: this.attr(0),
            lsof: this.attr(0),
            freshWater: this.attr(0),
            maxLsmgo: this.attr(0),
            maxLsof: this.attr(0),
            maxFreshWater: this.attr(0),
            usedLsmgo: this.attr([]),
            usedLsfo: this.attr([]),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId, voyageNo) {
                return this.get(`${shipId}/tops/${voyageNo}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
